<template>
  <dialog :open="isOpen" class="default-dialog" @click="closeModal">
    <div class="dialog-content text-center p-0 overflow-hidden" @click.stop>
      <div class="banner-top d-flex align-items-center justify-content-center p-4">
        <div class="icon-pulse">
           <i class="fas fa-crown text-white"></i>
        </div>
      </div>

      <div class="p-4 pt-5">
        <h3 class="font-weight-bolder text-dark mb-3">Plano Vencido 👑</h3>
        
        <p class="text-secondary mb-4 px-2">
          Seu plano mensal venceu e, para continuar utilizando os recursos do sistema, é necessário realizar a renovação.
        </p>

        <p class="text-sm text-secondary mb-4 px-3">
          Enquanto o plano estiver vencido, você poderá acessar sua conta normalmente, mas não poderá criar, editar ou publicar campanhas.
        </p>

        <div class="d-flex flex-column gap-2 mb-2">
          <button
            @click="renewPlan"
            class="btn btn-primary-gradient mb-0"
          >
            Renovar Plano
          </button>
          <button @click="closeModal" class="btn btn-outline-secondary mb-0">
            Entendi
          </button>
        </div>
      </div>
    </div>
  </dialog>
</template>

<script>
export default {
  name: "PlanExpiredModal",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$store.commit('setPlanExpiredModal', false);
    },
    renewPlan() {
      this.closeModal();
      this.$router.push('/plans');
    },
  },
};
</script>

<style scoped lang="scss">
.default-dialog {
  border: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  background: none;
  backdrop-filter: blur(8px);
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
}

dialog {
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.4s ease, transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  display: flex;
  flex-direction: column;
  align-items: center;
}

dialog[open] {
  opacity: 1;
  pointer-events: inherit;
}

.dialog-content {
  width: 450px;
  max-width: 95%;
  background: white;
  border-radius: 24px;
  z-index: 2;
  transform: translateY(20px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
}

dialog[open] .dialog-content {
  transform: translateY(0);
}

.banner-top {
  background: linear-gradient(135deg, #f1c40f 0%, #f39c12 100%);
  height: 120px;
  width: 100%;
  position: relative;
}

.icon-pulse {
  background: rgba(255, 255, 255, 0.2);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  animation: pulse 2s infinite;
  
  i {
    filter: drop-shadow(0 4px 6px rgba(0,0,0,0.2));
  }
}

@keyframes pulse {
  0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(241, 196, 15, 0.7); }
  70% { transform: scale(1); box-shadow: 0 0 0 15px rgba(241, 196, 15, 0); }
  100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(241, 196, 15, 0); }
}

.btn-primary-gradient {
  background: linear-gradient(135deg, #f1c40f 0%, #f39c12 100%);
  color: white;
  border: none;
  font-weight: 700;
  padding: 14px;
  border-radius: 12px;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(243, 156, 18, 0.4);
  }
}
</style>
